export enum ListOrder {
  Ascending = 'ASC',
  Descending = 'DESC',
}
